var map = {
	"./cs/groups.json": 6975,
	"./de/groups.json": 3474,
	"./en/groups.json": 1608,
	"./es/groups.json": 2310,
	"./fr/groups.json": 6136,
	"./it/groups.json": 3684,
	"./pl/groups.json": 5125,
	"./ru/groups.json": 8283,
	"./tr/groups.json": 6830,
	"./uk/groups.json": 6909,
	"./zh-CN/groups.json": 2258,
	"./zh-TW/groups.json": 4939
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9199;